import { render, staticRenderFns } from "./EventTypeSelector.vue?vue&type=template&id=0ef2706e&"
import script from "./EventTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./EventTypeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports